"use strict";

module.exports = () => () => undefined;
